import gql from 'graphql-tag';

export const deleteEmailGroup = gql`
  mutation deleteEmailGroup($id: String!) {
    deleteEmailGroup(id: $id)
  }
`;
